import { createContext } from 'react'

import { createContractDesingerStore } from '../store/createStore'

export const ContractDesignerContext = createContext<
  ReturnType<typeof createContractDesingerStore> | undefined
>(undefined)
